import { __exports as newPromiseCapability } from '../../../../../../_virtual/new-promise-capability.js';
export { __exports as default } from '../../../../../../_virtual/new-promise-capability.js';
import aCallable$1 from './a-callable.js';

var aCallable = aCallable$1;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
}; // `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability


newPromiseCapability.f = function (C) {
  return new PromiseCapability(C);
};
